export const getXAxisNameLabel = (text: string) => ({
  silent: true,
  type: 'group',
  // some chars (jg) are displayed below the line, so we need to add some padding
  bottom: 2,
  height: 20,
  left: 'center',
  children: [
    {
      type: 'text',
      style: {
        text,
        textAlign: 'center',
      },
    },
  ],
});
